import React from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';

let flag = 0;

class BookRecommendSlide extends React.PureComponent {
    state = {
        bookRecommendData: this.props.bookRecommendData,
    };

    sliderTmpl = list => {
        flag++;

        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => (
                          <a
                              href={item.url}
                              key={index}
                              className={styles.link}
                              imgindex={index}
                              ref={(flag === 2 || flag === 7) && index === 4 ? this.ref : ''}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title}>{item.title}</div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    sliderTmplFo = list => {
        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => (
                          <a href={item.url} key={index} className={styles.link} imgindex={index}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title}>{item.title}</div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    render() {
        let { bookRecommendData } = this.state;

        if (!(bookRecommendData instanceof Array)) {
            bookRecommendData = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        const newList = [bookRecommendData.slice(0, 5), bookRecommendData.slice(5, 10), bookRecommendData.slice(10)];
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: this.sliderTmpl,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        return (
            <Chip id="75149" type="recommend" title="上推广" groupName="正文" content={bookRecommendData}>
                <div className={styles.container}>
                    <div className={styles.tit}>热门好书</div>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            </Chip>
        );
    }
}

/**
 * 定义组件属性类型
 * */
BookRecommendSlide.propTypes = { bookRecommendData: PropTypes.array };

/**
 * 定义组件默认属性
 * */
BookRecommendSlide.defaultProps = {};

export { BookRecommendSlide };
export default errorBoundary(BookRecommendSlide);
